'use client';

import React from 'react';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import InstantSearchMobileLegacy from './instant-search-mobile/InstantSearchMobileLegacy';
import InstantSearchMobileNext from './instant-search-mobile';

const InstantSearchMobile = props => {
  const isBrowser = useIsBrowser();
  const postHogFlag = usePostHogFeatureFlag('consumerSearchBarNext');

  if (!isBrowser) {
    return <div />;
  }

  const useNextVersion = postHogFlag === 'test' || isNewConsumerApp;

  return useNextVersion ? (
    <InstantSearchMobileNext {...props} />
  ) : (
    <InstantSearchMobileLegacy {...props} />
  );
};

export default InstantSearchMobile;
